<div class="w9-task-list">
  <div class="w9-task-list__header">
    <div class="w9-task-list__title">Task list</div>
    <div class="w9-task-list__subtitle">What to do next</div>
  </div>

  @switch (state()) {
    @case ('loading') {
      <div class="w9-task-list__status">Loading your tasks…</div>
    }
    @case ('error') {
      <div class="w9-task-list__status">Couldn't load your tasks right now.</div>
    }
    @default {
      @if (visibleGroups().length === 0) {
        <div class="w9-task-list__status">You're all caught up.</div>
      } @else {
        @for (group of visibleGroups(); track group.code) {
          <div class="w9-task-list__group">
            @if (group.title) {
              <div class="w9-task-list__section-label">
                <span class="w9-task-list__dot"></span> {{ group.title }}
              </div>
            }
            @for (task of group.tasks; track task.code) {
              <div
                class="w9-task"
                [class.w9-task--done]="isDone(task)"
                [class.w9-task--in-progress]="isInProgress(task)"
              >
                <div class="w9-task__check">
                  @if (isDone(task)) {
                    <iris-icon name="check_circle" [size]="iconSizes.SM"></iris-icon>
                  } @else if (isInProgress(task)) {
                    <iris-icon name="pending" [size]="iconSizes.SM"></iris-icon>
                  } @else {
                    <iris-icon name="radio_button_unchecked" [size]="iconSizes.SM"></iris-icon>
                  }
                </div>
                <div class="w9-task__body">
                  <div class="w9-task__title-row">
                    <span class="w9-task__title">{{ task.title }}</span>
                    @if (isInProgress(task)) {
                      <span class="w9-task__status-label">In progress</span>
                    }
                  </div>
                  @if (task.description) {
                    <div class="w9-task__meta">{{ task.description }}</div>
                  }
                </div>
              </div>
            }
          </div>
        }
      }
    }
  }
</div>
